import { useSelector } from "react-redux";
import { useCallback, useEffect, useState } from "react";
import TransTable from "../common/TransTable";
import _ from "lodash";
import { Box, Button, IconButton, Switch, Typography, TextField, FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import { PageTitle } from "../common/PageTitle";
import { useDispatch } from "react-redux";
import { setLoading, setUsers } from "../../redux/action";
import { Link, useNavigate } from "react-router-dom";
import editicon from "../../images/editIcon.png";
import Iconify from "../common/Iconify";
import Capsule from "../common/Capsule";
import Axios from "axios";
import { base_url } from "../backendurl/url";
import { utcTimetoLocalTimeWithzone } from "../common/TransForm/Localdateformater";
import { Dateformater } from "../common/TransForm/dateFormater";
import { Config } from "../../utils/commonFuctions/Token";
import { RefreshToken } from "../../utils/commonFuctions/RefreshToken";
import ModalPopUp from "../common/TransForm/ModalPopUp";
import { Notification } from "../common/Notification";
import TransferPopupContent from "./TokenTransferPopup";
import { hasWritePermission } from "../common/PermissionUtility";

export default function TokenTransferList() {
  const navigate = useNavigate();
  const { users } = useSelector((state) => state);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  
  // Transfer popup states
  const [transferPopup, setTransferPopup] = useState(false);
  const [fromUser, setFromUser] = useState(''); // Now stores email
  const [toUser, setToUser] = useState(''); // Now stores email
  const [transferAmount, setTransferAmount] = useState('');
  const [usersList, setUsersList] = useState([]);
  const [fromUserData, setFromUserData] = useState({});
  const [toUserData, setToUserData] = useState({});
  const canWriteUsers = hasWritePermission('tokentransaction');
  
  
  // Validation states
  const [validationErrors, setValidationErrors] = useState({
    fromUser: '',
    toUser: '',
    transferAmount: ''
  });

  // Token transfers data
  const [tokenTransfers, setTokenTransfers] = useState([]);
  const [errorMessage, setErrorMessage] = useState('');
  const [notification, setNotification] = useState(false);
  
  // Server-side pagination states
  const [totalCount, setTotalCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [sortOrder, setSortOrder] = useState('');
  const [sortBy, setSortBy] = useState('');
  const [searchQuery, setSearchQuery] = useState('');

  // Token Transfer table columns
  const tokenTransferTableColumns = () => {
    return [
      { key: "transaction_id", label: "Transaction ID", align: "left", fontSize: "15px",
        valueRenderer: (data) => {
          return (
            <Typography style={{ color: "#3C50E0", cursor: "pointer" }}>
              {data["transaction_id"]}
            </Typography>
          );
        }
      },
      { key: "from", label: "From", align: "left", fontSize: "15px" },
      { key: "to", label: "To", align: "left", fontSize: "15px" },
      { 
        key: "date", 
        label: "Date", 
        align: "left", 
        fontSize: "15px",
        valueRenderer: (data) => {
          if (!data.date) {
            return <Typography>N/A</Typography>;
          }

          const dateObj = new Date(data.date);

          // If it's invalid (causing NaN/NaN/NaN in Dateformater)
          if (isNaN(dateObj)) {
            // Handle manually (assuming your API returns "dd/mm/yyyy" or similar)
            const [year, month, day] = data.date.split(/[-/]/);
            const fallback =
              day && month && year
                ? `${day.padStart(2, "0")}/${month.padStart(2, "0")}/${year}`
                : "Invalid Date";

            return <Typography>{fallback}</Typography>;
          }

          // Otherwise use common formatter
          return <Typography>{Dateformater(data.date)}</Typography>;
        },
      },
      { key: "action_by", label: "Action by", align: "left", fontSize: "15px" },
      { key: "token_transferred", label: "Token Transferred", align: "left", fontSize: "15px" },
      // { 
      //   key: "tokens_redeemed", 
      //   label: "Tokens Redeemed", 
      //   align: "left", 
      //   fontSize: "15px",
      //   valueRenderer: (data) => {
      //     return (
      //       <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
      //         <Typography>{data.tokens_redeemed || 0}</Typography>
      //         <Iconify 
      //           icon="material-symbols:info-outline" 
      //           size="small" 
      //           color="#64748B"
      //           sx={{ cursor: "pointer" }}
      //         />
      //       </Box>
      //     );
      //   }
      // }
    ];
  };

  // Excel export columns (without interactive elements)
  const tokenTransferExcelColumns = () => {
    return [
      { key: "transaction_id", label: "Transaction ID", align: "left", fontSize: "15px" },
      { key: "from", label: "From", align: "left", fontSize: "15px" },
      { key: "to", label: "To", align: "left", fontSize: "15px" },
      { 
        key: "date", 
        label: "Date", 
        align: "left", 
        fontSize: "15px",
        valueRenderer: (data, exportMode = false) => {
  if (!data.date) {
    return exportMode ? "N/A" : <Typography>N/A</Typography>;
  }

  const dateObj = new Date(data.date);

  if (isNaN(dateObj)) {
    const [year, month, day] = data.date.split(/[-/]/);
    const fallback =
      day && month && year
        ? `${day.padStart(2, "0")}/${month.padStart(2, "0")}/${year}`
        : "Invalid Date";
    return exportMode ? fallback : <Typography>{fallback}</Typography>;
  }

  const formatted = Dateformater(data.date);
  return exportMode ? formatted : <Typography>{formatted}</Typography>;
}
        //  valueRenderer: (data) => {
        //   if (!data.date) {
        //     return <Typography>N/A</Typography>;
        //   }

        //   const dateObj = new Date(data.date);

        //   // If it's invalid (causing NaN/NaN/NaN in Dateformater)
        //   if (isNaN(dateObj)) {
        //     // Handle manually (assuming your API returns "dd/mm/yyyy" or similar)
        //     const [year, month, day] = data.date.split(/[-/]/);
        //     const fallback =
        //       day && month && year
        //         ? `${day.padStart(2, "0")}/${month.padStart(2, "0")}/${year}`
        //         : "Invalid Date";

        //   //  return <Typography>{fallback}</Typography>;
        //   return "N/A";
        //   }

        //   // Otherwise use common formatter
        // //  return <Typography>{Dateformater(data.date)}</Typography>;
        // return Dateformater(data['date'])
        // },
        // valueRenderer: (data) => {
        //   return Dateformater(data['date']);
        // }
      },
      { key: "action_by", label: "Action by", align: "left", fontSize: "15px" },
      { key: "token_transferred", label: "Token Transferred", align: "left", fontSize: "15px" },
      // { key: "tokens_redeemed", label: "Tokens Redeemed", align: "left", fontSize: "15px" }
    ];
  };

  // Find user by email
  const findUserByEmail = (email) => {
    return usersList.find(user => user.email.toLowerCase() === email.toLowerCase());
  };

  // Enhanced validation function with more detailed checks
  const validateForm = () => {
    const errors = {
      fromUser: '',
      toUser: '',
      transferAmount: ''
    };

    let isValid = true;

    // Validate from user email
    if (!fromUser.trim()) {
      errors.fromUser = 'Please select from user';
      isValid = false;
    } else {
      const fromUserExists = findUserByEmail(fromUser);
      if (!fromUserExists) {
        errors.fromUser = 'User not found with this email';
        isValid = false;
      } else if (!fromUserExists.available_tokens || fromUserExists.available_tokens <= 0) {
        errors.fromUser = 'User has no available tokens to transfer';
        isValid = false;
      }
    }

    // Validate to user email
    if (!toUser.trim()) {
      errors.toUser = 'Please select to user';
      isValid = false;
    } else {
      const toUserExists = findUserByEmail(toUser);
      if (!toUserExists) {
        errors.toUser = 'User not found with this email';
        isValid = false;
      }
    }

    // Check if from and to emails are the same
    if (fromUser.trim() && toUser.trim() && fromUser.toLowerCase() === toUser.toLowerCase()) {
      errors.toUser = 'Cannot transfer to the same user';
      isValid = false;
    }

    // Validate transfer amount
    if (!transferAmount) {
      errors.transferAmount = 'Please enter transfer amount';
      isValid = false;
    } else {
      const amount = parseInt(transferAmount);
      const availableTokens = fromUserData.available_tokens || 0;
      
      if (amount <= 0) {
        errors.transferAmount = 'Transfer amount must be greater than 0';
        isValid = false;
      } else if (amount > availableTokens) {
        errors.transferAmount = `Insufficient tokens. Available: ${availableTokens}`;
        isValid = false;
      }
    }

    setValidationErrors(errors);
    return isValid;
  };

  // Get token transfers data
  const getTokenTransfers = useCallback(async (page = 1, limit = 10, orderBy = '', order = '', search = '') => {
    try {
      setLoading(true);
      
      let queryParams = `page=${page}&limit=${limit}`;
      
      if (orderBy && order) {
        queryParams += `&sort_by=${orderBy}&order=${order !== 'desc' ? 'desc' : 'asc'}`;
      }

      if (search && search.trim() !== '') {
        queryParams += `&search=${encodeURIComponent(search.trim())}`;
      }

      const response = await Axios.get(`${base_url}/api/accounts/admin/token-transfers/?${queryParams}`, Config);
      
      if (response?.status === 200) {
        let startIndex = (page - 1) * limit + 1;
        let data = response?.data?.results || [];
        
        data = data.map((item, index) => ({
          ...item,
          serial_no: startIndex + index
        }));
        
        setTokenTransfers(data);
        setTotalCount(response?.data?.count || 0);
      }
      
      setLoading(false);
    } catch (error) {
      setLoading(false);
      RefreshToken(error, setErrorMessage, setNotification);
    }
  }, []);

  // Get users list with available tokens
  const getUsersList = useCallback(async () => {
    try {
      const response = await Axios.get(`${base_url}/api/accounts/admin/token-transfer/`, Config);
      console.log("Users List Response:", response);
      if (response?.status === 200) {
        // Filter users to only show those with available tokens for better UX
        const allUsers = response?.data?.users || [];
        setUsersList(allUsers);
      }
    } catch (error) {
      RefreshToken(error, setErrorMessage, setNotification);
    }
  }, []);

  // Handle pagination change
  const handlePageChange = useCallback((page, rowsPerPage) => {
    setCurrentPage(page);
    setRowsPerPage(rowsPerPage);
    getTokenTransfers(page + 1, rowsPerPage, sortBy, sortOrder, searchQuery);
  }, [sortBy, sortOrder, searchQuery, getTokenTransfers]);

  // Handle sorting change
  const handleSortChange = useCallback((orderBy, order) => {
    setSortBy(orderBy);
    setSortOrder(order);
    setCurrentPage(0);
    getTokenTransfers(1, rowsPerPage, orderBy, order, searchQuery);
  }, [rowsPerPage, searchQuery, getTokenTransfers]);

  // Handle search
  const handleSearch = useCallback((searchValue) => {
    setSearchQuery(searchValue);
    setCurrentPage(0);
    getTokenTransfers(1, rowsPerPage, sortBy, sortOrder, searchValue);
  }, [rowsPerPage, sortBy, sortOrder, getTokenTransfers]);

  // Handle from user change (now receives email directly from autocomplete)
  const handleFromUserChange = (email) => {
    setFromUser(email);
    
    // Find user data by email
    const userData = findUserByEmail(email);
    setFromUserData(userData || {});
    
    // Clear validation errors
    setValidationErrors(prev => ({ ...prev, fromUser: '' }));
    
    // Reset "To" user if it's the same as "From" user
    if (toUser && email && toUser.toLowerCase() === email.toLowerCase()) {
      setToUser('');
      setToUserData({});
      setValidationErrors(prev => ({ ...prev, toUser: '' }));
    }

    // Reset transfer amount when changing from user
    setTransferAmount('');
    setValidationErrors(prev => ({ ...prev, transferAmount: '' }));
  };

  // Handle to user change (now receives email directly from autocomplete)
  const handleToUserChange = (email) => {
    setToUser(email);
    
    // Find user data by email
    const userData = findUserByEmail(email);
    setToUserData(userData || {});

    // Clear validation error
    setValidationErrors(prev => ({ ...prev, toUser: '' }));
  };

  // Handle transfer amount change with enhanced validation
  const handleTransferAmountChange = (event) => {
    const value = event.target.value;
    const amount = parseInt(value);
    const availableTokens = fromUserData.available_tokens || 0;
    
    setTransferAmount(value);
    
    // Real-time validation
    let error = '';
    if (value && amount <= 0) {
      error = 'Transfer amount must be greater than 0';
    } else if (value && amount > availableTokens) {
      error = `Insufficient tokens. Available: ${availableTokens}`;
    }
    
    setValidationErrors(prev => ({ ...prev, transferAmount: error }));
  };

  // Handle token transfer
  const handleTokenTransfer = async () => {
    try {
      // Validate form before submission
      if (!validateForm()) {
        return;
      }

      setLoading(true);

      // Get user IDs from emails
      const fromUserObj = findUserByEmail(fromUser);
      const toUserObj = findUserByEmail(toUser);

      const transferData = {
        from_user: fromUserObj.email,
        to_user: toUserObj.email,
        token_count: parseInt(transferAmount)
      };

      const response = await Axios.post(`${base_url}/api/accounts/admin/token-transfer/`, transferData, Config);
      
      if (response?.status === 200 || response?.status === 201) {
        // Close popup and reset form
        closeTransferPopup();
        
        // Refresh the table and users list (to update available tokens)
        getTokenTransfers(currentPage + 1, rowsPerPage, sortBy, sortOrder, searchQuery);
        getUsersList();
        
        // Show success message
        setErrorMessage('Token transfer completed successfully');
        setNotification(true);
      }
      
      setLoading(false);
    } catch (error) {
      setLoading(false);
      RefreshToken(error, setErrorMessage, setNotification);
    }
  };

  // Open transfer popup
  const openTransferPopup = () => {
    setTransferPopup(true);
    // Clear any previous validation errors
    setValidationErrors({
      fromUser: '',
      toUser: '',
      transferAmount: ''
    });
  };

  // Close transfer popup
  const closeTransferPopup = () => {
    setTransferPopup(false);
    setFromUser('');
    setToUser('');
    setTransferAmount('');
    setFromUserData({});
    setToUserData({});
    setValidationErrors({
      fromUser: '',
      toUser: '',
      transferAmount: ''
    });
  };

  //Excel Separate Functions
    const getAllUsersForExcel = async () => {
    try {
      setLoading(true);
      const response = await Axios.get(
        `${base_url}/api/accounts/admin/token-transfers/all/`, 
        Config
      );
       console.log("All Invoices for Token Excel:", response);
      if (response?.status === 200) {
        setLoading(false);
        return response?.data?.results || response?.data; 
      }
      setLoading(false);
      return [];
    } catch (error) {
      setLoading(false);
      RefreshToken(error, setErrorMessage, setNotification);
      return [];
    }
  };
  
 
  const [allExcelData, setAllExcelData] = useState([]);
  
  
  const handleExcelDownload = async () => {
    try {
      setLoading(true);
      const allUsersData = await getAllUsersForExcel();
      
      if (allUsersData.length > 0) {
        setAllExcelData(allUsersData);
        setTimeout(() => {
          setAllExcelData(allUsersData);
        }, 100);
      } else {
        setAllExcelData(users);
      }
    } catch (error) {
      console.error('Error downloading Excel:', error);
      setAllExcelData(users);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getTokenTransfers(1, 10);
    getUsersList();
  }, []);

  return (
    <>
      <Box>
        <TransTable
          pageTitle="Token Transfer"
          addBtnTitle="Transfer Token between users +"
          showSearch={true}
          showAddBtn={canWriteUsers}
          checkbox={false}
          columns={tokenTransferTableColumns()}
          excelColumns={tokenTransferExcelColumns()}
          rows={tokenTransfers}
          addBtnAction={openTransferPopup}
          filter_keys={['transaction_id', 'from_user', 'to_user', "action_by"]}
          isExcel={true}
          isLoading={loading}
          serverSide={true}
          totalCount={totalCount}
          currentPage={currentPage}
          rowsPerPage={rowsPerPage}
          onPageChange={handlePageChange}
          onSortChange={handleSortChange}
          onSearch={handleSearch}
          searchQuery={searchQuery}
          searchPlaceholder="Search by Transaction ID, Email Id"
          //Excel Separate Functions
          customExcelData={allExcelData}
        onExcelDownload={handleExcelDownload}
        />
        
        <Notification
          message={errorMessage}
          setopen={setNotification}
          type={errorMessage.includes('successfully') ? "success" : "error"}
          show={notification}
        />
      </Box>

      {/* Transfer Popup */}
      <ModalPopUp
        setPopup={setTransferPopup}
        openpopup={transferPopup}
        title="Transfer Tokens between users"
        customContent={
          <TransferPopupContent
            fromUser={fromUser}
            toUser={toUser}
            transferAmount={transferAmount}
            fromUserData={fromUserData}
            toUserData={toUserData}
            validationErrors={validationErrors}
            loading={loading}
            usersList={usersList}
            onFromUserChange={handleFromUserChange}
            onToUserChange={handleToUserChange}
            onTransferAmountChange={handleTransferAmountChange}
            onTransferSubmit={handleTokenTransfer}
            onCancel={closeTransferPopup}
          />
        }
        hideDefaultButtons={true}
      />
    </>
  );
}